import React from 'react';
import { Loader, Icon, Table, Button, Header, Label } from 'semantic-ui-react';
import moment from 'moment';
import FileSaver from 'file-saver';

import SelectAssetInReport from '../SelectAssetInReport';
import { alertMessage } from '../../../helper/alert-message';
import { reportView, reportDownloadExcel } from '../helper/dataService';
import { getIdsAndTime, getDuration } from '../helper/helper';
import reportsEnv from '../reportsEnv';

const { durationLimit, assetLimit } = reportsEnv.ignitionA;

class IgnitionA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      pdfDisableBtn: false,
      excelDisableBtn: false,
      selectedAssets: [],
      data: [],
      filteredEngineData: [],
      startTime: moment().startOf('day'),
      endTime: moment().endOf('day'),
    };
  }

  componentDidMount() {
    const {
      selectedAssets = [],
      startTime,
      endTime,
    } = JSON.parse(window.localStorage.getItem('reports_state'));

    this.setState({
      selectedAssets,
      startTime: moment(startTime),
      endTime: moment(endTime),
    });
  }

  getBack = () => {
    this.setState({
      data: [],
    });
  };

  downloadReport = () => {
    this.setState({
      active: true,
      pdfDisableBtn: false,
      excelDisableBtn: false,
    });

    const { ids, startTime, endTime } = getIdsAndTime(this.state);
    reportView(reportsEnv.ignitionA, {
      asset_ids: ids,
      from: startTime,
      to: endTime,
      speed_limit: 5,
    })
      .then((response) => {
        this.setState({
          data: response.data,
          active: false,
        });
      })
      .catch((error) => {
        this.setState({ active: false });
        alertMessage(`Sorry! Something went wrong`);
      });
  };

  handleDownloadExcelBtn = () => {
    this.setState({ excelDisableBtn: true });

    const { ids, startTime, endTime } = getIdsAndTime(this.state);
    reportDownloadExcel(reportsEnv.ignitionA, {
      asset_ids: ids,
      from: startTime,
      to: endTime,
      speed_limit: 5,
    })
      .then((response) => {
        FileSaver.saveAs(
          response.data,
          `Finder_Ignition_A_Report_${moment().format(
            'DD-MMMM-YYYY_hh:mm A',
          )}.xlsx`,
        );
        this.setState({ excelDisableBtn: false });
      })
      .catch((error) => {
        this.setState({ excelDisableBtn: false });
        alertMessage(`Sorry! Something went wrong`);
      });
  };

  render() {
    const {
      selectedAssets,
      data,
      active,
      pdfDisableBtn,
      excelDisableBtn,
      startTime,
      endTime,
    } = this.state;

    const duration = getDuration(endTime, startTime);
    const assetsQuantity = selectedAssets.length;

    const isDurationLimitCross = duration > durationLimit;
    const isAssetLimitCross = assetsQuantity > assetLimit;

    if (isDurationLimitCross) {
      alertMessage(
        `You can't select this report more than ${durationLimit} days.`,
      );
    } else if (isAssetLimitCross) {
      alertMessage(
        `You can't select this report more than ${assetLimit} assets.`,
      );
    }

    const title = `Ignition [A] [${durationLimit} days][${assetLimit} asset]`;
    const isValidDuration =
      duration > 0 && endTime.isSameOrAfter(startTime) && !isDurationLimitCross;
    const isValidAsset = assetsQuantity > 0 && !isAssetLimitCross;

    return (
      <div>
        {!active && data.length <= 0 && (
          <div className='center-report'>
            <Header as='h2'>{title}</Header>

            <div style={{ margin: '20px 0' }}>
              <Label.Group size='large'>
                <Label>
                  <Icon name='car' />
                  {assetsQuantity} assets
                </Label>
                <Label>
                  <Icon name='calendar' />
                  {duration} days
                </Label>
                <Label>
                  <Icon name='play' />
                  {moment(startTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}
                </Label>
                <Label>
                  <Icon name='stop' />
                  {moment(endTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}
                </Label>
              </Label.Group>
            </div>

            {isValidAsset && isValidDuration && (
              <Button.Group>
                <Button
                  color='black'
                  style={{ width: '200px', fontSize: '16px' }}
                  onClick={this.downloadReport}
                  icon='eye'
                  content='VIEW HERE'
                  disabled={pdfDisableBtn || excelDisableBtn}
                />

                <Button
                  color='teal'
                  style={{ width: '200px', fontSize: '16px' }}
                  icon='file excel outline'
                  content='Download Excel'
                  onClick={this.handleDownloadExcelBtn}
                  disabled={excelDisableBtn || pdfDisableBtn}
                  loading={excelDisableBtn}
                />
              </Button.Group>
            )}
          </div>
        )}

        {!active && data.length > 0 ? (
          <div style={{ margin: '2%' }}>
            <div className='left-right'>
              <div>
                <Header as='h2'>Ignition [A]</Header>
                <p>
                  Generated on: {moment().format('MMMM Do, YYYY, hh:mm:ss A')}
                </p>
              </div>
              <Button primary onClick={this.getBack}>
                Back
              </Button>
            </div>

            <br />
            {data.map((item, i) => (
              <div key={i} id={item.asset_detail.name}>
                <div className='ui stackable grid'>
                  <div className='eight wide column' style={{ paddingLeft: 0 }}>
                    <div className='ui card fluid'>
                      <div className='content'>
                        <div className='header'>{item.asset_detail.name}</div>

                        <div className='description'>
                          <div>
                            <p>
                              <i className='arrow right icon' /> From:
                              {moment(startTime).format(
                                'dddd, MMMM Do, YYYY, hh:mm:ss A',
                              )}
                            </p>
                            <p>
                              <i className='arrow right icon' /> Till:{' '}
                              {moment(endTime).format(
                                'dddd, MMMM Do, YYYY, hh:mm:ss A',
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='eight wide column'
                    style={{ paddingRight: 0 }}
                  >
                    <div className='ui card fluid'>
                      <ul className='content'>
                        <div className='ui left aligned icon header'>
                          • Total ignition on time:{' '}
                          {item.asset_detail.total_ignition_on_time ||
                            'Not Available'}
                        </div>

                        <div className='ui left aligned icon header'>
                          • While stopped (under 5 km/h):{' '}
                          {item.asset_detail.ignition_running_under_limit ||
                            'Not Available'}
                        </div>

                        <div className='ui left aligned icon header'>
                          • While running:{' '}
                          {item.asset_detail.ignition_on_over_limit ||
                            'Not Available'}
                        </div>

                        <div className='ui left aligned icon header'>
                          • Total ignition on{' '}
                          {item.asset_detail.total_engine_on || '0'} times.
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>

                <Table celled>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Started Time</Table.HeaderCell>
                      <Table.HeaderCell>Start Location</Table.HeaderCell>
                      <Table.HeaderCell>Stopped Time</Table.HeaderCell>
                      <Table.HeaderCell>End Location</Table.HeaderCell>
                      <Table.HeaderCell>
                        Awake Duration (Minute)
                      </Table.HeaderCell>
                      <Table.HeaderCell>Milage</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {item.ignition_status.map((last, idx) => {
                      return (
                        <Table.Row key={idx}>
                          <Table.Cell>
                            {last.ignition_started_at
                              ? moment(last.ignition_started_at.$date).format(
                                  'dddd, MMMM Do, YYYY, hh:mm:ss A',
                                )
                              : ''}
                          </Table.Cell>
                          <Table.Cell>
                            <ul>
                              {last.ignition_started_loc &&
                              last.ignition_started_loc.length > 0
                                ? last.ignition_started_loc.map(
                                    (item, index) => (
                                      <li key={index}>{item.name}</li>
                                    ),
                                  )
                                : ''}
                            </ul>
                          </Table.Cell>
                          <Table.Cell>
                            {last.ignition_stopped_at
                              ? moment(last.ignition_stopped_at.$date).format(
                                  'dddd, MMMM Do, YYYY, hh:mm:ss A',
                                )
                              : ''}
                          </Table.Cell>
                          <Table.Cell>
                            <ul>
                              {last.ignition_stopped_loc &&
                              last.ignition_stopped_loc.length > 0
                                ? last.ignition_stopped_loc.map(
                                    (item, index) => (
                                      <li key={index}>{item.name}</li>
                                    ),
                                  )
                                : ''}
                            </ul>
                          </Table.Cell>
                          <Table.Cell>{last.ignition_awake}</Table.Cell>
                          <Table.Cell>
                            {last.distance ? last.distance.toFixed(2) : ''}
                          </Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
                <br />
              </div>
            ))}
            {data.length > 1 ? <SelectAssetInReport assetList={data} /> : null}
          </div>
        ) : (
          <Loader active={active} inline='centered'>
            {' '}
            Generating...
          </Loader>
        )}
      </div>
    );
  }
}

export default IgnitionA;
